import { Link } from "react-router-dom"
import "./Footer.css"

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Goosnargh Pharmacy</h3>
            <p>Your trusted local pharmacy providing quality healthcare services to the Goosnargh community.</p>
          </div>

          <div className="footer-section">
            <h3>Quick Links</h3>
            <ul>
              <li>
                <Link to="/">Home</Link>
              </li>
              <li>
                <a href="/#services">Services</a>
              </li>
              <li>
                <a href="/#about">About Us</a>
              </li>
              <li>
                <a href="/#contact">Contact</a>
              </li>
              <li>
                <Link to="/nominate">Nominate Us</Link>
              </li>
            </ul>
          </div>

          <div className="footer-section">
            <h3>Contact Us</h3>
            <p>
              859 Whittingham Ln
              <br />
              Preston
              <br />
              PR3 2AU
            </p>
            <p>
              <strong>Phone:</strong> 01772 865238
              <br />
              <strong>Email:</strong> goosnarghpharmacy859@hotmail.com
            </p>
            <p>
              <strong>Superintendent Pharmacist:</strong> Nazir Vadva - 2035113
              <br />
              <strong>Premises GPhC Number:</strong> 1099449
            </p>
          </div>

          <div className="footer-section">
            <h3>Opening Hours</h3>
            <p>
              <strong>Monday - Thursday:</strong> 9am - 6pm
              <br />
              <strong>Friday:</strong> 9am - 1pm, 2pm - 6pm
              <br />
              <strong>Saturday - Sunday:</strong> Closed
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {new Date().getFullYear()} Goosnargh Pharmacy. All rights reserved.</p>
          <div className="footer-links">
            <Link to="/privacy-policy">Privacy Policy</Link>
            <Link to="/terms-of-service">Terms of Service</Link>
            <Link to="/accessibility">Accessibility</Link>
            <Link to="/admin/login" className="admin-link">Admin</Link>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer
